import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import {
  getb2b,
  getPackage,
  searchSpeciality,
  getInsuredUsers,
  updatePackage,
  gettagstearwise,
  getcouponstagwise,
  getAllGroupDataForProductCatalogue,
  getFlashCreditTypes,
  getCountry,
  GetAllDoctors,
} from "../../../Listfunction";
import InputColor from "react-input-color";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editProductCatalogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_logo: null,
      package_LogoData: "",
      oldCompanyLogofile: "",
      package_description: "",
      package_name: "",
      productCode: "",
      package_nameError: null,
      package_duration: "",
      free_trial: "",
      package_durationError: null,
      package_price: "",
      package_priceError: null,
      feature_chkError: null,
      n_o_calls: "",
      n_o_callsError: null,
      raya_discount: "",
      raya_discountError: null,
      lab_discount: "",
      lab_discountError: null,
      express_order: "",
      express_orderError: null,
      medicin_discount: "",
      medicin_discountError: null,
      cardHidden: true,
      processing: true,
      feature_chk: [],
      background_color: "",
      user_type: "1",
      package_type: "1",
      duration_type: "1",
      free_trial_type: "1",
      is_featured: "0",
      familyType: "1",
      doctorspecialityItems: [],
      insurance_item: [],
      specialityList: [],
      insurance_details: [],
      insurance_data: [],
      address_line_1: "",
      address_line_2: "",
      discounted_price: "",
      addresslist: [
        {
          srno: 1,
          address_line_1: "",
          address_line_2: "",
        },
      ],
      tagList: [],
      tagListOption: [],
      couponList: [],
      coupon_id: [],
      couponTitleId: [],
      standardFree: "",
      standardDiscount: "",
      standardBasePrice: "",
      expressFree: "",
      expressDiscount: "",
      expressBasePrice: "",
      islandWideFree: "",
      islandWideDiscount: "",
      islandWideBasePrice: "",
      noOfFreeValue: "",
      groupData: [],
      selectedGroup: [],
      claimValue: "",
      // claimPeriod: "",
      isClaimMedicine: false,
      isClaimLab: false,
      isClaimRaya: false,
      isClaimTalkNow: false,
      isClaimTalkLater: false,
      isClaimTalkGlobal: false,
      isClaimEchanneling: false,
      isHospitalization: false,
      // claimPeriodType: "",
      policyDetails: "",
      creditTypeList: [],
      creditType: "",
      medicinePolicyDetails: "",
      labPolicyDetails: "",
      rayaPolicyDetails: "",
      talkNowPolicyDetails: "",
      talkLaterPolicyDetails: "",
      talkGlobalPolicyDetails: "",
      oldPolicyDetails: [],
      deliveryWelcomeNote: "",
      isClaimFamily: false,
      isClaimMother: false,
      isClaimFather: false,
      isClaimSister: false,
      isClaimBrother: false,
      isClaimSpouse: false,
      isClaimChild: false,
      claimFamilyType: [],
      packageLogoError: null,
      feature_chk_data: [
        {
          id: 6,
          chk_value: 6,
          label: "Medicine",
          checked: false,
          placeholder: "Enter Discount",
          name: "medicine_discount",
          input_value: "",
          errorMessage: "Medicine discount is required.",
          isFlashCreditMedicine: false,
        },
        {
          id: 3,
          chk_value: 3,
          label: "Lab",
          checked: false,
          placeholder: "Enter Discount",
          name: "lab_discount",
          input_value: "",
          errorMessage: "Lab Discount is required.",
          isFlashCreditLab: false,
        },
        {
          id: 2,
          chk_value: 2,
          label: "Raya",
          checked: false,
          placeholder: "Enter Discount",
          name: "raya_flat_discount",
          input_value: "",
          errorMessage: "Raya Discount is required.",
          isFlashCreditRaya: false,
        },
        {
          id: 1,
          chk_value: 1,
          label: "Talk now",
          checked: false,
          placeholder: "Talk now",
          name: "no_of_calls",
          input_value: "",
          errorMessage: "Talk now is required.",
          unlimited: false,
          isFlashCreditTalkNow: false,
        },
        {
          id: 10,
          chk_value: 10,
          label: "Talk global",
          checked: false,
          placeholder: "Talk global ",
          name: "no_of_talk_global_calls",
          input_value: "",
          errorMessage: "Talk Later Global is required.",
          talkGlobelUnlimited: false,
          isFlashCreditTalkGlobal: false,
        },
        {
          id: 11,
          chk_value: 11,
          label: "Talk later",
          checked: false,
          placeholder: "Talk later",
          name: "no_of_talk_later_calls",
          input_value: "",
          errorMessage: "Talk Later is required.",
          talkLaterUnlimited: false,
          isFlashCreditTalkLater: false,
        },
        {
          id: 8,
          chk_value: 8,
          label: "Talk later speciality",
          checked: false,
          placeholder: "Talk later",
          name: "no_of_calls_talk_later",
          input_value: [],
          errorMessage: "Talk later is required.",
        },
        {
          id: 4,
          chk_value: 4,
          label: "MBE",
          checked: false,
          placeholder: "MBE Price",
          name: "mbe_price",
          input_value: "",
          errorMessage: "MBE Price is required.",
        },
        {
          id: 5,
          chk_value: 5,
          label: "Delivery",
          checked: false,
          placeholder: "N.O Deliveries",
          name: "delivery",
          input_value: [
            {
              type: "standard",
              free: null,
              discount: null,
              base_price: null,
            },
            {
              type: "express",
              free: null,
              discount: null,
              base_price: null,
            },
            {
              type: "islandWide",
              free: null,
              discount: null,
              base_price: null,
            },
          ],
          errorMessage: "N.O Delivery is required.",
          standard: false,
          express: false,
          islandWide: false,
        },
        {
          id: 7,
          chk_value: 7,
          label: "Insurance",
          checked: false,
          placeholder: "N.O Insurance",
          name: "no_of_insurance_order",
          input_value: "",
          insurance_key_value: [],
          insurance_id: [],
          errorMessage: "N.O Insurance order is required.",
        },
        {
          id: 9,
          chk_value: 9,
          label: "Partner & Coupon Management",
          checked: false,
          placeholder: "Partner & Coupon Management",
          name: "partner_and_coupon_management",
          input_value: "",
          value: [],
          errorMessage: "Partner & Coupon Management is required.",
        },
        {
          id: 12,
          chk_value: 12,
          label: "MBE Groups",
          checked: false,
          placeholder: "Select Group",
          name: "group",
          value: [],
          errorMessage: "Group is required.",
        },
        {
          id: 13,
          chk_value: 13,
          label: "Claim Module",
          checked: false,
          name: "claim",
          value: [],
          policyDetails: [],
          errorMessage: "Claim is required.",
        },
        {
          id: 14,
          chk_value: 14,
          label: "Talk Later Doctor wise",
          checked: false,
          name: "talkLaterDoctorWise",
          input_value: [],
          errorMessage: "Talk now doctor is required.",
        },
      ],
      country_detail: [],
      country_code: "",
      countryError: null,
      getAllDoctors: [],
      opdFamilyPrice: null,
      opdIndividualPrice: null,
      claimBillingCycle: null,
      claimBillingCycleOptions: [
        {
          label: "Monthly",
          value: "monthly",
        },
        {
          label: "Weekly",
          value: "weekly",
        },
      ],
      claimType: null,
      claimTypeOptions: [
        {
          label: "Per Employee",
          value: "per_employee",
        },
        {
          label: "Per Claim",
          value: "per_claim",
        },
      ],
      isUnlimitedClaim: false,
      isSystemClaimAllowed: true,
      isBankAccountNeeded: true,
      isBankAccountDetailsDisable: false,
      splitInvoicesByCompany: false,
      deliveryDeductFromClaim: true,
      poolValue: null,
      claimValueError: null,
      pharma: "",
      lab: "",
      consult: "",
      hospital: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handlePackageLogoFileChange =
      this.handlePackageLogoFileChange.bind(this);
  }

  userType = [
    { value: 1, label: "B2B" },
    { value: 2, label: "B2C" },
    { value: 3, label: "B2B2C" },
  ];

  packageType = [
    { value: 1, label: "Normal" },
    { value: 2, label: "Basic" },
  ];

  duration_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  free_trial_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  familyType = [
    { value: 1, label: "Mother" },
    { value: 2, label: "Father" },
    { value: 3, label: "Spouse" },
    { value: 3, label: "Children" },
  ];

  editorval = null;

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var id = JSON.parse(localStorage.getItem("packageId"));

    getFlashCreditTypes(obj).then((cdata) => {
      const flashCreditTypes = cdata.data;
      const CreditTypeOptions = flashCreditTypes.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      this.setState({
        creditTypeList: CreditTypeOptions,
      });
    });

    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    getAllGroupDataForProductCatalogue(obj)
      .then((response1) => {
        var data = response1;
        this.setState({
          groupData: data.data,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });

    searchSpeciality(obj).then((response) => {
      const mdata = response.data;
      var activespeciality = [];
      for (let i = 0; i < mdata.length; i++) {
        if (mdata[i].is_active == 1) {
          activespeciality.push(mdata[i]);
        }
      }

      let pcItems = [];
      activespeciality.map((x, i) => {
        pcItems.push({ value: x.id, label: x.title });
      });

      this.setState({
        doctorspecialityItems: pcItems,
        specialityList: activespeciality,
      });
    });

    GetAllDoctors(obj).then((response) => {
      const mdata = response.data.data;
      const getAllDoctors = mdata.map((data) => {
        return {
          value: data.id,
          label: data.name,
        };
      });
      this.setState({ getAllDoctors: getAllDoctors });
    });

    let riderItems = [];
    getInsuredUsers(obj).then((res) => {
      const data = res.data;
      data.data.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        insuranceUsers: riderItems,
      });
    });

    setTimeout(async () => {
      await getPackage(id, obj).then((response) => {
        var packageData = response.data.data;
        var p_feature = response.data.data.packageFeatures;
        let list = [...this.state.feature_chk_data];
        let policy = packageData.policy;

        this.setState({
          package_name: packageData.title,
          package_duration: packageData.duration,
          package_price: packageData.price,
          package_description: packageData.description,
          duration_type: packageData.duration_type,
          background_color: packageData.background_color,
          user_type: packageData.user_type,
          package_type: packageData.package_type.toString(),
          free_trial: packageData.free_trial,
          free_trial_type: packageData.free_trial_type,
          discounted_price: packageData.discounted_price,
          is_featured: JSON.stringify(packageData.is_featured),
          isAia: packageData.is_aia === 1 ? true : false,
          productCode: packageData.product_code,
          country_code: packageData.country_code,
          package_LogoData: packageData.package_logo,
        });

        // Sort Object With category_id
        p_feature.sort((a, b) => (a.category_id > b.category_id ? 1 : -1));
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < p_feature.length; j++) {
            if (list[i].chk_value == p_feature[j].category_id) {
              if (p_feature[j].value) {
                if (p_feature[j].category_id == "8") {
                  var pcvalue = [];
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    for (
                      let xi = 0;
                      xi < JSON.parse(p_feature[j].value).length;
                      xi++
                    ) {
                      var opt_value = "";

                      const specialityId =
                        this.state.doctorspecialityItems.find(
                          (data) =>
                            data.value ===
                            JSON.parse(p_feature[j].value)[xi].speciality_id,
                        );
                      opt_value = specialityId;
                      var details = {
                        specility: opt_value,
                        no_of_calls: JSON.parse(p_feature[j].value)
                          ? JSON.parse(p_feature[j].value)[xi].no_of_calls
                          : "",
                        isUnlimited: JSON.parse(p_feature[j].value)
                          ? JSON.parse(p_feature[j].value)[xi].no_of_calls ==
                            "unlimited"
                            ? true
                            : false
                          : "",
                      };
                      pcvalue.push(details);
                    }
                    list[i]["input_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                } else if (p_feature[j].category_id == "9") {
                  var pcvalue = [];
                  if (p_feature[j].coupons.length > 0) {
                    for (let xi = 0; xi < p_feature[j].coupons.length; xi++) {
                      var data_ins = {
                        id: p_feature[j].coupons
                          ? p_feature[j].coupons[xi].id
                          : "",
                        title: p_feature[j].coupons
                          ? p_feature[j].coupons[xi].title
                          : "",
                      };
                      pcvalue.push(data_ins);
                    }
                    list[i]["value"] = pcvalue;
                    list[i]["checked"] = true;

                    pcvalue.map((a, b) => this.state.coupon_id.push(a.id));
                  }
                } else if (p_feature[j].category_id == "12") {
                  var pcvalue = [];
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    for (
                      let xi = 0;
                      xi < JSON.parse(p_feature[j].value).length;
                      xi++
                    ) {
                      const alpha = this.state.groupData.find(
                        (item) =>
                          item.id ===
                          Number(JSON.parse(p_feature[j].value)[xi]),
                      );
                      pcvalue.push(alpha);
                    }
                    list[i]["value"] = pcvalue;
                    list[i]["checked"] = true;

                    pcvalue.map((a, b) =>
                      this.state.selectedGroup.push(JSON.stringify(a.id)),
                    );
                  }
                } else if (p_feature[j].category_id == "13") {
                  var pcvalue = [];
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    //   // get all values and set state
                    const claimData = JSON.parse(p_feature[j].value).map(
                      (item) => {
                        return {
                          claimValue: item.value,
                          // claimPeriod: item.period,
                          isClaimMedicine: item.medicine,
                          isClaimLab: item.lab,
                          isClaimRaya: item.raya,
                          isClaimTalkNow: item.talkNow,
                          isClaimTalkLater: item.talkLater,
                          isClaimTalkGlobal: item.talkGlobal,
                          isClaimEchanneling: item.eChanneling,
                          isClaimFamily: item.talkFamily,
                          isClaimMother: item.talkFamilyMother,
                          isClaimFather: item.talkFamilyFather,
                          isClaimBrother: item.talkFamilyBrother,
                          isClaimSister: item.talkFamilySister,
                          isClaimSpouse: item.talkFamilySpouse,
                          isClaimChild: item.talkFamilyChild,
                          // claimPeriodType: {value: item.periodType, label: item.periodType},
                          creditType: item.creditType,
                          opdIndividualPrice: item.opdIndividual,
                          opdFamilyPrice: item.opdFamilyPrice,
                          claimBillingCycle: item.billingCycle,
                          isUnlimitedClaim: item.isUnlimitedAllocation,
                          isSystemClaimAllowed: item.isSystemClaimAllowed,
                          isBankAccountNeeded: item.isBankAccountNeeded,
                          isBankAccountDetailsDisable:
                            item.isBankAccountDetailsDisable,
                          splitInvoicesByCompany:
                            item.splitInvoicesByCompany !== undefined
                              ? item.splitInvoicesByCompany
                              : false,
                          deliveryDeductFromClaim:
                            item.deliveryDeductFromClaim !== undefined
                              ? item.deliveryDeductFromClaim
                              : item.delivery_deduct_from_claim === undefined
                                ? true
                                : item.delivery_deduct_from_claim,
                          isHospitalization: item.hospitalization,
                          poolValue: item.poolValue,
                          claimType: item.claimType,
                          pharma:
                            item.manualClaims &&
                            item.manualClaims.find((mc) => mc == "Pharma")
                              ? "Pharma"
                              : "",
                          lab:
                            item.manualClaims &&
                            item.manualClaims.find((mc) => mc == "Lab")
                              ? "Lab"
                              : "",
                          consult:
                            item.manualClaims &&
                            item.manualClaims.find((mc) => mc == "Consult")
                              ? "Consult"
                              : "",
                          hospital:
                            item.manualClaims &&
                            item.manualClaims.find((mc) => mc == "Hospital")
                              ? "Hospital"
                              : "",
                        };
                      },
                    );
                    // create editor
                    policy.map((data) => {
                      const contentBlock = htmlToDraft(data.policy);
                      const contentState = ContentState.createFromBlockArray(
                        contentBlock.contentBlocks,
                      );
                      const editorState =
                        EditorState.createWithContent(contentState);
                      if (data.type_title === "medicine") {
                        this.setState({
                          medicinePolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      } else if (data.type_title === "lab") {
                        this.setState({
                          labPolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      } else if (data.type_title === "raya") {
                        this.setState({
                          rayaPolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      } else if (data.type_title === "talkNow") {
                        this.setState({
                          talkNowPolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      } else if (data.type_title === "talkLater") {
                        this.setState({
                          talkLaterPolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      } else if (data.type_title === "talkGlobal") {
                        this.setState({
                          talkGlobalPolicyDetails: {
                            id: data.id,
                            title: data.type_title,
                            value: editorState,
                            isOldClaimPolicy: true,
                          },
                        });
                      }
                    });
                    // const contentBlock = htmlToDraft(p_feature[j].policy);
                    // const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    // const editorState = EditorState.createWithContent(contentState);

                    // this.editorval = editorState
                    this.setState({ ...claimData[0] });
                    list[i]["checked"] = true;
                    this.setState({ oldPolicyDetails: policy });

                    //   pcvalue.map((a, b) => this.state.selectedGroup.push(JSON.stringify(a.id)));
                  }
                } else if (p_feature[j].category_id == "7") {
                  var pcvalue = [];
                  if (p_feature[j].insurance_data.length > 0) {
                    for (
                      let xi = 0;
                      xi < p_feature[j].insurance_data.length;
                      xi++
                    ) {
                      var data_ins = {
                        address_line_1: p_feature[j].insurance_data
                          ? p_feature[j].insurance_data[xi].insurance_key
                          : "",
                        address_line_2: p_feature[j].insurance_data
                          ? p_feature[j].insurance_data[xi].insurance_value
                          : "",
                      };
                      pcvalue.push(data_ins);
                    }
                    list[i]["insurance_key_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                  if (p_feature[j].insurance_id) {
                    const insuranceUserOption = riderItems.filter(
                      (item) =>
                        item.value === parseInt(p_feature[j].insurance_id),
                    );
                    if (!!insuranceUserOption.length) {
                      list[i]["input_value"] = insuranceUserOption[0];
                    }
                  }
                } else if (p_feature[j].category_id == "5") {
                  var pcvalue = [];
                  if (p_feature[j].value.length > 0) {
                    for (let xi = 0; xi < p_feature[j].value.length - 1; xi++) {
                      if (
                        p_feature[j].value[xi].free !== 0 ||
                        p_feature[j].value[xi].discount !== 0 ||
                        p_feature[j].value[xi].base_price !== 0
                      ) {
                        if (xi === 0) {
                          list[i]["standard"] = true;
                        } else if (xi === 1) {
                          list[i]["express"] = true;
                        } else if (xi === 2) {
                          list[i]["islandWide"] = true;
                        }
                        list[i]["checked"] = true;
                      }
                    }
                    this.setState({
                      standardFree:
                        p_feature[j].value[0].free === 0
                          ? ""
                          : p_feature[j].value[0].free,
                    });
                    this.setState({
                      standardDiscount:
                        p_feature[j].value[0].discount === 0
                          ? ""
                          : p_feature[j].value[0].discount,
                    });
                    this.setState({
                      standardBasePrice:
                        p_feature[j].value[0].base_price === 0
                          ? ""
                          : p_feature[j].value[0].base_price,
                    });
                    this.setState({
                      expressFree:
                        p_feature[j].value[1].free === 0
                          ? ""
                          : p_feature[j].value[1].free,
                    });
                    this.setState({
                      expressDiscount:
                        p_feature[j].value[1].discount === 0
                          ? ""
                          : p_feature[j].value[1].discount,
                    });
                    this.setState({
                      expressBasePrice:
                        p_feature[j].value[1].base_price === 0
                          ? ""
                          : p_feature[j].value[1].base_price,
                    });
                    this.setState({
                      islandWideFree:
                        p_feature[j].value[2].free === 0
                          ? ""
                          : p_feature[j].value[2].free,
                    });
                    this.setState({
                      islandWideDiscount:
                        p_feature[j].value[2].discount === 0
                          ? ""
                          : p_feature[j].value[2].discount,
                    });
                    this.setState({
                      islandWideBasePrice:
                        p_feature[j].value[2].base_price === 0
                          ? ""
                          : p_feature[j].value[2].base_price,
                    });
                    this.setState({
                      noOfFreeValue:
                        p_feature[j].value[3].t_count === 0
                          ? ""
                          : p_feature[j].value[3].t_count,
                    });

                    list[i]["input_value"] = p_feature[j].value;
                  }
                } else if (p_feature[j].category_id == "14") {
                  var pcvalue = [];
                  if (JSON.parse(p_feature[j].value).length > 0) {
                    for (
                      let xi = 0;
                      xi < JSON.parse(p_feature[j].value).length;
                      xi++
                    ) {
                      var opt_value = "";
                      const doctorId = this.state.getAllDoctors.find(
                        (data) =>
                          data.value ===
                          JSON.parse(p_feature[j].value)[xi].doctorId,
                      );
                      opt_value = doctorId;
                      var details = {
                        doctorId: opt_value,
                        noOfCalls: JSON.parse(p_feature[j].value)
                          ? JSON.parse(p_feature[j].value)[xi].noOfCalls
                          : "",
                      };
                      pcvalue.push(details);
                    }
                    let selectedDoctors = pcvalue.map((itemY) => {
                      return itemY.doctorId.value;
                    });
                    let removeSelectedDoctors = this.state.getAllDoctors.filter(
                      (itemX) => !selectedDoctors.includes(itemX.value),
                    );
                    this.setState({ getAllDoctors: removeSelectedDoctors });
                    list[i]["input_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                } else {
                  if (
                    p_feature[j].category_id == "1" &&
                    p_feature[j].value == "unlimited"
                  ) {
                    list[i]["unlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "1" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditTalkNow"] = true;
                  }
                  if (
                    p_feature[j].category_id == "10" &&
                    p_feature[j].value == "unlimited"
                  ) {
                    list[i]["talkGlobelUnlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "10" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditTalkGlobal"] = true;
                  }
                  if (
                    p_feature[j].category_id == "11" &&
                    p_feature[j].value == "unlimited"
                  ) {
                    list[i]["talkLaterUnlimited"] = true;
                  }
                  if (
                    p_feature[j].category_id == "11" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditTalkLater"] = true;
                  }
                  if (
                    p_feature[j].category_id == "6" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditMedicine"] = true;
                  }
                  if (
                    p_feature[j].category_id == "3" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditLab"] = true;
                  }
                  if (
                    p_feature[j].category_id == "2" &&
                    p_feature[j].is_flash_credit_usable == true
                  ) {
                    list[i]["isFlashCreditRaya"] = true;
                  }
                  list[i]["input_value"] = p_feature[j].value;
                  list[i]["checked"] = true;
                }
                this.setState({ feature_chk_data: list });
              }
            }
          }
        }

        this.setState({ feature_chk: list, cardHidden: false });
      });
    }, 700);

    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  handleAllChecked_noc = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      if (list[i]["label"] == "Talk now") {
        list[i]["input_value"] = "";
        list[i]["unlimited"] = false;
      } else {
        list[i]["input_value"] = [];
        list[i]["unlimited"] = false;
      }
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedMedicine = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["isFlashCreditMedicine"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedLab = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;
    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["isFlashCreditLab"] = false;
    }
    this.setState({ feature_chk: list });
  };

  handleAllCheckedRaya = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["isFlashCreditRaya"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedTalkGlobal = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["talkGlobelUnlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedTalkLater = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["talkLaterUnlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllChecked_noi = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["insurance_key_value"] = [];
      list[i]["unlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedGroups = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["value"] = [];
    }

    this.setState({ feature_chk: list });
  };

  onChange = (e, i) => {
    const target = e.target;
    const value = target.value;
    const re = /^\d*\.?\d*$/;

    if (re.test(value) == true) {
      var list = [...this.state.feature_chk_data];
      list[i]["input_value"] = value;
      this.setState({ feature_chk: list });
    }
  };

  onDoctorSelectChange = (value, i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    if (value.value !== arr_val[idx].doctorId.value) {
      let removedDoctor = arr_val[idx].doctorId;
      this.state.getAllDoctors.push({
        value: removedDoctor.value,
        label: removedDoctor.label,
      });
    }
    arr_val[idx].doctorId = value;
    list[i]["input_value"] = arr_val;
    let selectedDoctors = arr_val.map((itemY) => {
      return itemY.doctorId.value;
    });
    let removeSelectedDoctors = this.state.getAllDoctors.filter(
      (itemX) => !selectedDoctors.includes(itemX.value),
    );
    this.setState({ feature_chk: list, getAllDoctors: removeSelectedDoctors });
  };

  onSpecialityChange = (value, i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[idx].specility = value;
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onInsuranceChange = (value, i, q) => {
    var list = [...this.state.feature_chk_data];
    list[i]["input_value"] = value;
    this.setState({ feature_chk: list });
  };

  onCallChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value) == true) {
      var list = [...this.state.feature_chk_data];
      var arr_val = list[i]["input_value"];
      arr_val[idx].no_of_calls = e.target.value;
      list[i]["input_value"] = arr_val;
      this.setState({ feature_chk: list });
    }
  };
  onCallDoctorSpecialityWiseChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value) == true) {
      var list = [...this.state.feature_chk_data];
      var arr_val = list[i]["input_value"];
      arr_val[idx].noOfCalls = e.target.value;
      list[i]["input_value"] = arr_val;
      this.setState({ feature_chk: list });
    }
  };
  handleInputChangeAddresslist1 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val[y].address_line_1 = e.target.value;
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };
  handleInputChangeAddresslist2 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val[y].address_line_2 = e.target.value;
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallAdd = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.push({
      specility: "",
      no_of_calls: "",
      isUnlimited: false,
    });
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallRemove = (i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.splice(idx, 1);
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onTalkLaterDoctorWiseRemove = (i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    let removedDoctor = arr_val[idx].doctorId;
    if (arr_val[idx].doctorId.value != "") {
      this.state.getAllDoctors.push({
        value: removedDoctor.value,
        label: removedDoctor.label,
      });
    }
    arr_val.splice(idx, 1);
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onInsuranceRemove = (i, x) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val.splice(x, 1);
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  handleAllChecked = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;
    if (checked == false) {
      list[i]["input_value"] = "";
    }
    this.setState({ feature_chk: list });
  };

  onAddNewSpecialityDoctor = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.push({
      doctorId: "",
      noOfCalls: "",
    });
    list[i]["input_value"] = arr_val;
    let selectedDoctors = arr_val.map((itemY) => {
      return itemY.doctorId.value;
    });
    let removeSelectedDoctors = this.state.getAllDoctors.filter(
      (itemX) => !selectedDoctors.includes(itemX.value),
    );
    this.setState({ feature_chk: list, getAllDoctors: removeSelectedDoctors });
  };

  onNOCallAdd_test = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val.push({
      address_line_1: "",
      address_line_2: "",
    });
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onChange_tier = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ tiers: value });

    await gettagstearwise(value, obj).then((res) => {
      const data = res.data;
      const tagoptions = data.tags.map((x, i) => {
        return {
          value: x,
          label: x,
        };
      });
      var current = this.state.tagListOption;
      current[value] = tagoptions;
      this.setState({ tagListOption: current });
    });
  };

  onChange_tags = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;
    this.setState({ tags: value });

    const tiers = this.state.tiers;
    await getcouponstagwise(value, tiers, userToken).then((res) => {
      const data = res.data;
      const coupunoptions = data.coupons.map((x, i) => {
        return {
          id: x.id,
          title: x.title,
        };
      });

      this.setState({ couponList: coupunoptions });
    });
  };

  onChange_coupons = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;
    const couponSelect = this.state.couponList.filter(
      (item) => item.id === parseInt(value),
    );
    const featureCheckData = this.state.feature_chk_data.map((item) => {
      if (item.id === 9) {
        return {
          ...item,
          value: [...item.value, couponSelect[0]],
        };
      }
      return item;
    });
    this.state.coupon_id.push(value);
    this.setState({
      feature_chk_data: featureCheckData,
      couponList: [],
      tagListOption: [],
    });
  };

  onChangeGroups = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const selectedGroup = this.state.groupData.filter(
      (item) => item.id === parseInt(value),
    );
    const featureCheckData = this.state.feature_chk_data.map((item) => {
      if (item.id === 12) {
        return {
          ...item,
          value: [...item.value, selectedGroup[0]],
        };
      }
      return item;
    });
    this.state.selectedGroup.push(value);
    this.setState({ feature_chk_data: featureCheckData });
    target.value = "";
  };

  onRemove_coupon(i, indexs) {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["value"];
    arr_val.splice(indexs, 1);
    list[i]["value"] = arr_val;
    this.setState({ feature_chk: list });

    this.state.coupon_id.splice(indexs, 1);
    var remove_cpn = this.state.coupon_id;
    this.setState({ coupon_id: remove_cpn });
  }

  onRemove_group(i, indexs) {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["value"];
    arr_val.splice(indexs, 1);
    list[i]["value"] = arr_val;
    this.setState({ feature_chk: list });

    this.state.selectedGroup.splice(indexs, 1);
    var remove_group = this.state.selectedGroup;
    this.setState({ selectedGroup: remove_group });
  }

  handleAllCheckedFreeDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    this.setState({
      feature_chk: list,
      standardFree: "",
      standardDiscount: "",
      standardBaseprice: "",
      expressFree: "",
      expressDiscount: "",
      expressBasePrice: "",
      islandWideFree: "",
      islandWideDiscount: "",
      islandWideBasePrice: "",
    });
  };

  handleStandardDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["standard"] = checked;
    this.setState({
      feature_chk: list,
      standardFree: "",
      standardDiscount: "",
      standardBasePrice: "",
    });
  };

  handleExpressDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["express"] = checked;
    this.setState({
      feature_chk: list,
      expressFree: "",
      expressDiscount: "",
      expressBasePrice: "",
    });
  };
  handleIslandWideDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["islandWide"] = checked;
    this.setState({
      feature_chk: list,
      islandWideFree: "",
      islandWideDiscount: "",
      islandWideBasePrice: "",
    });
  };

  onChangeDeliveryFields = (e, i, type) => {
    const re = /^[0-9]*$/;
    const { value } = e.target;
    if (re.test(value) && e.target.name == "noOfFreeDelivery") {
      this.setState({ noOfFreeValue: value });
    } else if (e.target.name == "standradFree" && re.test(value)) {
      this.setState({ standardFree: value });
    } else if (e.target.name == "standradDiscount" && re.test(value)) {
      this.setState({ standardDiscount: value });
    } else if (e.target.name == "standradBasePrice" && re.test(value)) {
      this.setState({ standardBasePrice: value });
    } else if (e.target.name == "expressFree" && re.test(value)) {
      this.setState({ expressFree: value });
    } else if (e.target.name == "expressDiscount" && re.test(value)) {
      this.setState({ expressDiscount: value });
    } else if (e.target.name == "expressBasePrice" && re.test(value)) {
      this.setState({ expressBasePrice: value });
    } else if (e.target.name == "isLandWideFree" && re.test(value)) {
      this.setState({ islandWideFree: value });
    } else if (e.target.name == "isLandWideDiscount" && re.test(value)) {
      this.setState({ islandWideDiscount: value });
    } else if (e.target.name == "isLandWideBasePrice" && re.test(value)) {
      this.setState({ islandWideBasePrice: value });
    } else if (e.target.name == "welcomeNote") {
      this.setState({ deliveryWelcomeNote: value });
    }
  };

  onSubmit = async () => {
    if (!!this.state.package_logo) {
      this.setState({ processing: true });
      const fdata = new FormData();
      fdata.append("company_logo", this.state.package_logo);

      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          this.setState({
            package_LogoData: res.data.data.company_logo_url,
          });
        });
    }
    // else {
    //   this.setState({ package_LogoData: this.state.package_LogoData });
    // }

    let error = false;
    if (this.state.package_name.length == 0) {
      error = true;
      this.setState({
        package_nameError: (
          <small className="text-danger">Package Name is required.</small>
        ),
      });
    } else {
      this.setState({ package_nameError: null });
    }

    if (this.state.package_duration.length == 0) {
      error = true;
      this.setState({
        package_durationError: (
          <small className="text-danger">Duration is required.</small>
        ),
      });
    } else {
      this.setState({ package_durationError: null });
    }

    if (this.state.package_price.length == 0) {
      error = true;
      this.setState({
        package_priceError: (
          <small className="text-danger">Price is required.</small>
        ),
      });
    } else {
      this.setState({ package_priceError: null });
    }
    if (!this.state.country_code || this.state.country_code === "0") {
      error = true;
      this.setState({
        countryError: (
          <small className="text-danger">Country is required.</small>
        ),
      });
    } else {
      this.setState({ countryError: null });
    }
    if (!this.state.package_logo && !this.state.package_LogoData) {
      error = true;
      this.setState({
        packageLogoError: (
          <small className="text-danger">Package logo is required.</small>
        ),
      });
    } else {
      this.setState({ packageLogoError: null });
    }

    if (this.state.feature_chk.length == 0) {
      error = true;
      this.setState({
        feature_chkError: (
          <small className="text-danger">Feature is required.</small>
        ),
      });
    } else {
      this.setState({ feature_chkError: null });
    }

    const getClaimFeatureData = this.state.feature_chk_data.find(
      (data) => data.chk_value == "13",
    );
    if (getClaimFeatureData && getClaimFeatureData.checked) {
      if (
        (this.state.claimValue == "" || this.state.claimValue == null) &&
        this.state.isUnlimitedClaim == false
      ) {
        error = true;
        this.setState({
          feature_chkError: (
            <small className="text-danger">
              Claim allocation or unlimited claim is required.
            </small>
          ),
        });
      } else {
        this.setState({ feature_chkError: null });
      }
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var id = JSON.parse(localStorage.getItem("packageId"));

      const featureArr = this.state.feature_chk;
      const featureData = [];

      featureArr.map((s, i) => {
        if (s.name == "no_of_calls_talk_later") {
          var pcvalue = [];
          for (let xi = 0; xi < s.input_value.length; xi++) {
            var speid = s.input_value[xi].specility
              ? s.input_value[xi].specility.value
              : "";
            pcvalue.push({
              speciality_id: speid,
              no_of_calls: s.input_value[xi].no_of_calls,
            });
          }

          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: pcvalue,
          });
        } else if (s.name == "partner_and_coupon_management") {
          const cpn_id = this.state.coupon_id;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: cpn_id,
          });
        } else if (s.name == "delivery") {
          const standardFreeValue = this.state.standardFree;
          const standardDiscountValue = this.state.standardDiscount;
          const standardBasepriceValue = this.state.standardBasePrice;
          const expressFreeValue = this.state.expressFree;
          const expressDiscountValue = this.state.expressDiscount;
          const expressBasepriceValue = this.state.expressBasePrice;
          const islandWideFreeValue = this.state.islandWideFree;
          const islandWideDiscountValue = this.state.islandWideDiscount;
          const islandWideBasepriceValue = this.state.islandWideBasePrice;
          const noOfFreeDelivery = this.state.noOfFreeValue;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: [
              {
                free: standardFreeValue == "" ? 0 : standardFreeValue,
                discount:
                  standardDiscountValue == "" ? 0 : standardDiscountValue,
                base_price:
                  standardBasepriceValue == "" ? 0 : standardBasepriceValue,
                type: "standard",
              },
              {
                free: expressFreeValue == "" ? 0 : expressFreeValue,
                discount: expressDiscountValue == "" ? 0 : expressDiscountValue,
                base_price:
                  expressBasepriceValue == "" ? 0 : expressBasepriceValue,
                type: "express",
              },
              {
                free: islandWideFreeValue == "" ? 0 : islandWideFreeValue,
                discount:
                  islandWideDiscountValue == "" ? 0 : islandWideDiscountValue,
                base_price:
                  islandWideBasepriceValue == "" ? 0 : islandWideBasepriceValue,
                type: "island_wide",
              },
              {
                type: "sum",
                t_count: noOfFreeDelivery == "" ? 0 : noOfFreeDelivery,
              },
            ],
          });
        } else if (s.name == "group") {
          const groupId = this.state.selectedGroup;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: groupId,
          });
        } else if (s.name == "medicine_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditMedicine,
          });
        } else if (s.name == "lab_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditLab,
          });
        } else if (s.name == "raya_flat_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditRaya,
          });
        } else if (s.name == "no_of_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkNow,
          });
        } else if (s.name == "no_of_talk_global_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkGlobal,
          });
        } else if (s.name == "no_of_talk_later_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkLater,
          });
        } else if (s.name == "claim") {
          const claimValue = this.state.claimValue;
          // const claimPeriod = this.state.claimPeriod;
          const isClaimMedicine = this.state.isClaimMedicine;
          const isClaimLab = this.state.isClaimLab;
          const isClaimRaya = this.state.isClaimRaya;
          const isClaimTalkNow = this.state.isClaimTalkNow;
          const isClaimTalkLater = this.state.isClaimTalkLater;
          const isClaimTalkGlobal = this.state.isClaimTalkGlobal;
          const isClaimEchanneling = this.state.isClaimEchanneling;
          const isHospitalization = this.state.isHospitalization;
          const isClaimFamily = this.state.isClaimFamily;
          const isClaimMother = this.state.isClaimMother;
          const isClaimFather = this.state.isClaimFather;
          const isClaimBrother = this.state.isClaimBrother;
          const isClaimSister = this.state.isClaimSister;
          const isClaimSpouse = this.state.isClaimSpouse;
          const isClaimChild = this.state.isClaimChild;
          // const claimPeriodType = this.state.claimPeriodType.value;
          const creditType = 4;
          const policyDetails = !!this.editorval
            ? draftToHtml(convertToRaw(this.editorval.getCurrentContent()))
            : "";
          const opdIndividualPrice = !!this.state.opdIndividualPrice
            ? this.state.opdIndividualPrice
            : "";
          const opdFamilyPrice = !!this.state.opdFamilyPrice
            ? this.state.opdFamilyPrice
            : "";
          const claimBillingCycle = !!this.state.claimBillingCycle
            ? this.state.claimBillingCycle
            : "";
          const isUnlimitedClaimAllocation = this.state.isUnlimitedClaim;
          const isSystemClaimAllowed = this.state.isSystemClaimAllowed;
          const isBankAccountNeeded = this.state.isBankAccountNeeded;
          const splitInvoicesByCompany = this.state.splitInvoicesByCompany;
          const deliveryDeductFromClaim = this.state.deliveryDeductFromClaim;
          const poolValue = this.state.poolValue;
          const claimType = this.state.claimType;
          const manualClaimFeature = [
            this.state.pharma !== "" ? this.state.pharma : null,
            this.state.lab !== "" ? this.state.lab : null,
            this.state.consult !== "" ? this.state.consult : null,
            this.state.hospital !== "" ? this.state.hospital : null,
          ].filter((item) => item !== null);
          if (s.checked === true) {
            if (
              isClaimFamily == false &&
              isClaimMedicine == false &&
              isClaimLab == false &&
              isClaimRaya == false &&
              isClaimTalkNow == false &&
              isClaimTalkLater == false &&
              isClaimTalkGlobal == false &&
              isClaimEchanneling == false &&
              isHospitalization == false &&
              isUnlimitedClaimAllocation == false &&
              (claimValue == "" || claimValue == null)
            ) {
              featureData.push({
                category_id: s.chk_value,
                title: s.name,
                value: [],
                policy: policyDetails,
              });
            } else {
              featureData.push({
                category_id: s.chk_value,
                title: s.name,
                value: [
                  {
                    value: claimValue,
                    // period: claimPeriod,
                    medicine: isClaimMedicine,
                    lab: isClaimLab,
                    raya: isClaimRaya,
                    talkNow: isClaimTalkNow,
                    talkLater: isClaimTalkLater,
                    talkGlobal: isClaimTalkGlobal,
                    eChanneling: isClaimEchanneling,
                    hospitalization: isHospitalization,
                    talkFamily: isClaimFamily,
                    talkFamilyMother: isClaimFamily && isClaimMother,
                    talkFamilyFather: isClaimFamily && isClaimFather,
                    talkFamilyBrother: isClaimFamily && isClaimBrother,
                    talkFamilySister: isClaimFamily && isClaimSister,
                    talkFamilySpouse: isClaimFamily && isClaimSpouse,
                    talkFamilyChild: isClaimFamily && isClaimChild,
                    // periodType: claimPeriodType,
                    creditType: creditType,
                    opdIndividual: opdIndividualPrice,
                    opdFamilyPrice: opdFamilyPrice,
                    billingCycle: claimBillingCycle,
                    isUnlimitedAllocation: isUnlimitedClaimAllocation,
                    isSystemClaimAllowed: isSystemClaimAllowed,
                    isBankAccountNeeded: isBankAccountNeeded,
                    isBankAccountDetailsDisable:
                      this.state.isBankAccountDetailsDisable,
                    splitInvoicesByCompany: splitInvoicesByCompany,
                    deliveryDeductFromClaim: deliveryDeductFromClaim,
                    poolValue: poolValue,
                    manualClaims: manualClaimFeature,
                    claimType: claimType,
                  },
                ],
                policy: policyDetails,
              });
            }
            // featureData.push({
            //   category_id: s.chk_value,
            //   title: s.name,
            //   value: [
            //     // {
            //     //   value: claimValue,
            //     //   // period: claimPeriod,
            //     //   medicine: isClaimMedicine,
            //     //   lab: isClaimLab,
            //     //   raya: isClaimRaya,
            //     //   talkNow: isClaimTalkNow,
            //     //   talkLater: isClaimTalkLater,
            //     //   talkGlobal: isClaimTalkGlobal,
            //     //   talkFamily:isClaimFamily,
            //     //   // periodType: claimPeriodType,
            //     //   creditType: creditType,
            //     // },
            //   ],
            //   policy: policyDetails,
            // });
          } else {
            featureData.push({
              category_id: s.chk_value,
              title: s.name,
              value: [],
              policy: policyDetails,
            });
          }
        } else if (s.name == "talkLaterDoctorWise") {
          const selectedDoctorId = s.input_value.map((item) => {
            return {
              doctorId: item.doctorId.value,
              noOfCalls: item.noOfCalls,
            };
          });
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: selectedDoctorId,
          });
        } else {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
          });
        }
      });

      let insuranceData = [];
      const insurances = this.state.feature_chk_data.find(
        (data) => data.chk_value == "7",
      );
      if (insurances.input_value.length) {
        insurances.input_value.map((x) => {
          insuranceData.push({
            insurance_key: x.address_line_1,
            insurance_value: x.address_line_2,
          });
        });
      } else {
        insuranceData = [];
      }

      var user_type_p = parseInt(this.state.user_type);
      var package_type_p = parseInt(this.state.package_type);
      var insurance =
        this.state.feature_chk_data["7"]["input_value"] != undefined
          ? this.state.feature_chk_data["7"]["input_value"].value
          : null;

      let claimValue = [];
      let deleteClaimPolicyId = [];
      deleteClaimPolicyId = [...deleteClaimPolicyId];
      claimValue = [...claimValue];
      if (
        this.state.medicinePolicyDetails &&
        this.state.medicinePolicyDetails !== ""
      ) {
        if (this.state.medicinePolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.medicinePolicyDetails.id);
        }
        claimValue.push({
          title: this.state.medicinePolicyDetails.title,
          value: !!this.state.medicinePolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.medicinePolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      if (this.state.labPolicyDetails && this.state.labPolicyDetails !== "") {
        if (this.state.labPolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.labPolicyDetails.id);
        }
        claimValue.push({
          title: this.state.labPolicyDetails.title,
          value: !!this.state.labPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.labPolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      if (this.state.rayaPolicyDetails && this.state.rayaPolicyDetails !== "") {
        if (this.state.rayaPolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.rayaPolicyDetails.id);
        }
        claimValue.push({
          title: this.state.rayaPolicyDetails.title,
          value: !!this.state.rayaPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.rayaPolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      if (
        this.state.talkNowPolicyDetails &&
        this.state.talkNowPolicyDetails !== ""
      ) {
        if (this.state.talkNowPolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.talkNowPolicyDetails.id);
        }
        claimValue.push({
          title: this.state.talkNowPolicyDetails.title,
          value: !!this.state.talkNowPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkNowPolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      if (
        this.state.talkLaterPolicyDetails &&
        this.state.talkLaterPolicyDetails !== ""
      ) {
        if (this.state.talkLaterPolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.talkLaterPolicyDetails.id);
        }
        claimValue.push({
          title: this.state.talkLaterPolicyDetails.title,
          value: !!this.state.talkLaterPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkLaterPolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      if (
        this.state.talkGlobalPolicyDetails &&
        this.state.talkGlobalPolicyDetails !== ""
      ) {
        if (this.state.talkGlobalPolicyDetails.isUpdated) {
          deleteClaimPolicyId.push(this.state.talkGlobalPolicyDetails.id);
        }
        claimValue.push({
          title: this.state.talkGlobalPolicyDetails.title,
          value: !!this.state.talkGlobalPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkGlobalPolicyDetails.value.getCurrentContent(),
                ),
              )
            : "",
        });
      }
      updatePackage(
        this.state.package_name,
        this.state.package_description,
        this.state.package_duration,
        this.state.duration_type,
        this.state.package_price,
        this.state.background_color,
        featureData,
        insuranceData,
        insurance,
        user_type_p,
        package_type_p,
        this.state.is_featured,
        this.state.free_trial,
        this.state.free_trial_type,
        this.state.discounted_price,
        this.state.productCode,
        this.state.country_code,
        this.state.package_LogoData,
        claimValue,
        deleteClaimPolicyId,
        obj,
        id,
      )
        .then((res) => {
          if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Catalogue Package</b> - Updated Successfully.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/productcatalogue");
    }, 3000);
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{getApiErrorMessage(error)}</div>,
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  setColor = (colors) => {
    this.setState({
      background_color: colors.hex,
    });
  };

  onnumricfieldChange(e) {
    const { value } = e.target;
    const re = /^[0-9]*$/;

    if (e.target.name == "package_price") {
      if (re.test(value) == true) {
        this.setState({ package_price: value });

        if (value == "") {
          this.setState({
            package_priceError: (
              <small className="text-danger">Price is required.</small>
            ),
          });
        } else {
          this.setState({ package_priceError: null });
        }
      }
    }

    if (e.target.name == "discounted_price") {
      if (re.test(value) == true) {
        this.setState({ discounted_price: value });
      }
    }

    if (e.target.name == "package_duration") {
      if (re.test(value) == true) {
        this.setState({ package_duration: value });

        if (value == "") {
          this.setState({
            package_durationError: (
              <small className="text-danger">Duration is required.</small>
            ),
          });
        } else {
          this.setState({ package_durationError: null });
        }
      }
    }
  }

  handleFlashCreditMedicine = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditMedicine"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditMedicine"] = true;
    } else {
      list[i]["isFlashCreditMedicine"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditLab = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditLab"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditLab"] = true;
    } else {
      list[i]["isFlashCreditLab"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditRaya = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditRaya"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditRaya"] = true;
    } else {
      list[i]["isFlashCreditRaya"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkLterSpeciality = (e, i, idx) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[idx].isUnlimited = e.target.checked;
    list[i]["input_value"] = arr_val;

    if (checked) {
      arr_val[idx].no_of_calls = "unlimited";
    } else {
      arr_val[idx].no_of_calls = "";
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkLater = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkLater"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkLater"] = true;
    } else {
      list[i]["isFlashCreditTalkLater"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkNow = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkNow"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkNow"] = true;
    } else {
      list[i]["isFlashCreditTalkNow"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkGlobal = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkGlobal"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkGlobal"] = true;
    } else {
      list[i]["isFlashCreditTalkGlobal"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkGlobel = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["talkGlobelUnlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkLater = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["talkLaterUnlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedMbe = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["unlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  onChangeShowMobileApp = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;

    this.setState({
      is_featured: value,
    });
  };

  handleAllClaim(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == true) {
      list[i]["checked"] = true;
    } else {
      list[i]["checked"] = false;
      this.setState({
        claimValue: "",
        // claimPeriod: "",
        isClaimMedicine: false,
        isClaimLab: false,
        isClaimRaya: false,
        isClaimTalkGlobal: false,
        isClaimTalkLater: false,
        isClaimTalkNow: false,
      });
      this.editorval = null;
    }

    this.setState({ feature_chk: list });
  }

  onEditorStateChange = (type, editorState) => {
    if (type === "medicine") {
      const medicinePolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "medicine",
      );
      const oldPolicyData = medicinePolicy ? medicinePolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (medicinePolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          medicinePolicyDetails: {
            id: medicinePolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          medicinePolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    } else if (type === "lab") {
      const labPolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "lab",
      );
      const oldPolicyData = labPolicy ? labPolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (labPolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          labPolicyDetails: {
            id: labPolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          labPolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    } else if (type === "raya") {
      const rayaPolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "raya",
      );
      const oldPolicyData = rayaPolicy ? rayaPolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (rayaPolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          rayaPolicyDetails: {
            id: rayaPolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          rayaPolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    } else if (type === "talkNow") {
      const talkNowPolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "talkNow",
      );
      const oldPolicyData = talkNowPolicy ? talkNowPolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (talkNowPolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          talkNowPolicyDetails: {
            id: talkNowPolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          talkNowPolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    } else if (type === "talkLater") {
      const talkLaterPolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "talkLater",
      );
      const oldPolicyData = talkLaterPolicy ? talkLaterPolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (talkLaterPolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          talkLaterPolicyDetails: {
            id: talkLaterPolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          talkLaterPolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    } else if (type === "talkGlobal") {
      const talkGlobalPolicy = this.state.oldPolicyDetails.find(
        (data) => data.type_title === "talkGlobal",
      );
      const oldPolicyData = talkGlobalPolicy ? talkGlobalPolicy.policy : "";
      const currentPolicyData = !!editorState
        ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
        : "";
      if (talkGlobalPolicy && oldPolicyData != currentPolicyData) {
        this.setState({
          talkGlobalPolicyDetails: {
            id: talkGlobalPolicy.id,
            title: type,
            value: editorState,
            isUpdated: true,
          },
        });
      } else {
        this.setState({
          talkGlobalPolicyDetails: {
            title: type,
            value: editorState,
            isUpdated: false,
          },
        });
      }
    }
  };

  findFlashCreditType() {
    const creditTypeValue = this.state.creditTypeList.find(
      (data) => data.value === this.state.creditType,
    );
    return creditTypeValue;
  }

  findClaimBillingCycle() {
    const claimBillingCycle = this.state.claimBillingCycleOptions.find(
      (data) => data.value === this.state.claimBillingCycle,
    );
    console.log("claimBillingCycle", claimBillingCycle);
    console.log("claimBillingCycle", this.state.claimBillingCycle);
    if (!claimBillingCycle) {
      return;
    } else {
      return claimBillingCycle;
    }
  }

  findClaimType() {
    const claimType = this.state.claimTypeOptions.find(
      (data) => data.value === this.state.claimType,
    );
    console.log("claimType", claimType);
    console.log("claimType", this.state.claimType);
    if (!claimType) {
      return;
    } else {
      return claimType;
    }
  }

  findClaimFamilyType() {
    let familyItems = [];

    this.familyType.map((x, i) => {
      familyItems.push({ value: x.value, label: x.label });
    });

    this.setState({
      claimFamilyType: familyItems,
    });
  }
  uploadPackagelLogo() {
    document.getElementById("selectpackage_logo").click();
  }
  handlePackageLogoFileChange(event) {
    this.setState({ package_logo: event.target.files[0] });
    this.setState({
      packageLogoError: null,
    });
  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col lg={10} md={12} sm={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Type</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="user_type"
                            value={this.state.user_type}
                            onChange={(event) => {
                              this.setState({ user_type: event.target.value });
                            }}
                          >
                            {this.userType.map((ut, idx) => (
                              <option key={idx} value={ut.value}>
                                {ut.label}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Basic Type</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="package_type"
                            value={this.state.package_type}
                            onChange={(event) => {
                              this.setState({
                                package_type: event.target.value,
                              });
                            }}
                          >
                            {this.packageType.map((ut, idx) => (
                              <option key={idx} value={ut.value}>
                                {ut.label}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                        {this.state.user_type == 2 ? (
                          <FormGroup>
                            <ControlLabel>Show in mobile app</ControlLabel>

                            <div className="order_source_data">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="600"
                                option="1"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "1"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="601"
                                option="0"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "0"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        ) : null}
                        <FormGroup>
                          <ControlLabel>Package Name</ControlLabel>
                          <FormControl
                            name="package_name"
                            value={this.state.package_name}
                            onChange={(event) => {
                              this.setState({
                                package_name: event.target.value,
                              });
                              event.target.value === ""
                                ? this.setState({
                                    package_nameError: (
                                      <small className="text-danger">
                                        Package name is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ package_nameError: null });
                            }}
                            placeholder="Enter Package Name"
                            type="text"
                          />
                          {this.state.package_nameError}
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Product Code</ControlLabel>
                          <FormControl
                            name="productCode"
                            value={this.state.productCode}
                            onChange={(event) => {
                              this.setState({
                                productCode: event.target.value,
                              });
                            }}
                            placeholder="Enter Product Code"
                            type="text"
                          />
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Package Description</ControlLabel>
                          <FormControl
                            name="package_description"
                            value={this.state.package_description}
                            onChange={(event) => {
                              this.setState({
                                package_description: event.target.value,
                              });
                            }}
                            placeholder="Enter Package Description"
                            type="text"
                          />
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Free Trail</ControlLabel>
                          <Row>
                            <Col sm={6}>
                              <select
                                className="react-select primary form-control durationselect_package"
                                name="free_trial_type"
                                value={this.state.free_trial_type}
                                onChange={(event) => {
                                  this.setState({
                                    free_trial_type: event.target.value,
                                  });
                                }}
                              >
                                {this.free_trial_type.map((ut, idx) => (
                                  <option key={idx} value={ut.value}>
                                    {ut.label}
                                  </option>
                                ))}
                              </select>
                            </Col>
                            <Col sm={6}>
                              <FormControl
                                name="free_trial"
                                value={this.state.free_trial}
                                onChange={(event) => {
                                  this.setState({
                                    free_trial: event.target.value,
                                  });
                                }}
                                placeholder="Enter Package Free Trail"
                                type="text"
                              />
                            </Col>
                          </Row>
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Package Duration</ControlLabel>
                          <Row>
                            <Col sm={6}>
                              <FormControl
                                name="package_duration"
                                value={this.state.package_duration}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Package Duration"
                                type="text"
                              />
                              {this.state.package_durationError}
                            </Col>
                            <Col sm={6}>
                              <select
                                className="react-select primary form-control durationselect_package"
                                name="duration_type"
                                value={this.state.duration_type}
                                onChange={(event) => {
                                  this.setState({
                                    duration_type: event.target.value,
                                  });
                                }}
                              >
                                {this.duration_type.map((ut, idx) => (
                                  <option key={idx} value={ut.value}>
                                    {ut.label}
                                  </option>
                                ))}
                              </select>
                            </Col>
                          </Row>
                        </FormGroup>

                        <Row>
                          <FormGroup>
                            <Col sm={6}>
                              <ControlLabel>Package Price</ControlLabel>
                              <FormControl
                                name="package_price"
                                value={this.state.package_price}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Package Price"
                                type="text"
                              />
                              {this.state.package_priceError}
                            </Col>

                            <Col sm={6}>
                              <ControlLabel>Discount</ControlLabel>

                              <FormControl
                                name="discounted_price"
                                value={this.state.discounted_price}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Discount Price"
                                type="text"
                              />
                            </Col>
                          </FormGroup>
                        </Row>
                        <Row>
                          <Col sm={6}>
                            <ControlLabel>Country</ControlLabel>
                            <select
                              name="country"
                              value={this.state.country_code}
                              onChange={(event) => {
                                this.setState({
                                  country_code: event.target.value,
                                });
                                this.setState({ countryError: null });
                              }}
                              className="form-control"
                            >
                              <React.Fragment>
                                <option value="0">Select Country</option>
                                {this.state.country_detail.map(
                                  (country_data) => (
                                    <option value={country_data.country_code}>
                                      {country_data.country_name}
                                    </option>
                                  ),
                                )}
                              </React.Fragment>
                            </select>
                            {this.state.countryError}
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={6}>
                            <ControlLabel>Package Logo</ControlLabel>
                            <br></br>
                            <input
                              style={{ display: "none" }}
                              id="selectpackage_logo"
                              type="file"
                              className="form-control"
                              name="package_logo"
                              onChange={this.handlePackageLogoFileChange}
                            />
                            <Button
                              onClick={this.uploadPackagelLogo}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.package_logo == ""
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.package_logo == ""
                                ? "Choose Package Logo"
                                : "Change Package Logo"}
                            </Button>
                          </Col>
                        </Row>
                        {this.state.packageLogoError}

                        <FormGroup className="backgroundcolorinput">
                          <ControlLabel>Background Color</ControlLabel>
                          <InputColor
                            initialValue={this.state.background_color}
                            onChange={this.setColor}
                            placement="right"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Package Features</ControlLabel>
                          <div className="grp-feature">
                            {this.state.feature_chk_data.map((s, i) => (
                              <React.Fragment key={i}>
                                {s.label == "Medicine" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedMedicine(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{ display: "inline-flex" }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              number={s.id + 999}
                                              key={i + 999}
                                              checked={s.isFlashCreditMedicine}
                                              onChange={(e) =>
                                                this.handleFlashCreditMedicine(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditMedicine}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Lab" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 8000}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedLab(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{ display: "inline-flex" }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              number={s.id + 998}
                                              key={i + 998}
                                              checked={s.isFlashCreditLab}
                                              onChange={(e) =>
                                                this.handleFlashCreditLab(e, i)
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditLab}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Raya" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 799}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedRaya(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{ display: "inline-flex" }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              number={s.id + 997}
                                              key={i + 997}
                                              checked={s.isFlashCreditRaya}
                                              onChange={(e) =>
                                                this.handleFlashCreditRaya(e, i)
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditRaya}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Talk global" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 798}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedTalkGlobal(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "baseline",
                                        }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              disabled={
                                                s.isFlashCreditTalkGlobal
                                              }
                                              number={s.id + 220}
                                              key={i + 220}
                                              checked={s.talkGlobelUnlimited}
                                              onChange={(e) =>
                                                this.handleUnlimitedTalkGlobel(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Unlimited"
                                              value={s.talkGlobelUnlimited}
                                            />
                                            <Checkbox
                                              disabled={s.talkGlobelUnlimited}
                                              number={s.id + 993}
                                              key={i + 993}
                                              checked={
                                                s.isFlashCreditTalkGlobal
                                              }
                                              onChange={(e) =>
                                                this.handleFlashCreditTalkGlobal(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditTalkGlobal}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Talk later" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 1052}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedTalkLater(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "baseline",
                                        }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              disabled={
                                                s.isFlashCreditTalkLater
                                              }
                                              number={s.id + 221}
                                              key={i + 221}
                                              checked={s.talkLaterUnlimited}
                                              onChange={(e) =>
                                                this.handleUnlimitedTalkLater(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Unlimited"
                                              value={s.talkLaterUnlimited}
                                            />
                                            <Checkbox
                                              disabled={s.talkLaterUnlimited}
                                              number={s.id + 996}
                                              key={i + 996}
                                              checked={s.isFlashCreditTalkLater}
                                              onChange={(e) =>
                                                this.handleFlashCreditTalkLater(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditTalkLater}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Talk later speciality" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 796}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked_noc(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div className="productcat-select">
                                        {s.checked && (
                                          <>
                                            <Button
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              style={{
                                                marginTop: "4px",
                                                marginBottom: "20px",
                                              }}
                                              onClick={() =>
                                                this.onNOCallAdd(i)
                                              }
                                            >
                                              Add
                                            </Button>
                                            <div className="pct_flaxcontainer">
                                              {s.input_value.length > 0 &&
                                                s.input_value.map(
                                                  (pccl, idx) => (
                                                    <div className="productcat_callcontainer">
                                                      <Select
                                                        className="pcat_callselect"
                                                        placeholder="Speciality"
                                                        closeMenuOnSelect={true}
                                                        value={pccl.specility}
                                                        onChange={(value) =>
                                                          this.onSpecialityChange(
                                                            value,
                                                            i,
                                                            idx,
                                                          )
                                                        }
                                                        options={
                                                          this.state
                                                            .doctorspecialityItems
                                                        }
                                                      />
                                                      <FormControl
                                                        disabled={
                                                          pccl.isUnlimited
                                                        }
                                                        value={pccl.no_of_calls}
                                                        placeholder="Number of Calls"
                                                        name={s.name}
                                                        type="text"
                                                        onChange={(e) =>
                                                          this.onCallChange(
                                                            e,
                                                            i,
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      &nbsp;
                                                      <Checkbox
                                                        number={
                                                          s.id + 1201 + idx
                                                        }
                                                        key={i + 1201 + idx}
                                                        checked={
                                                          pccl.isUnlimited
                                                        }
                                                        onChange={(e) =>
                                                          this.handleUnlimitedTalkLterSpeciality(
                                                            e,
                                                            i,
                                                            idx,
                                                          )
                                                        }
                                                        label="Unlimited"
                                                        value={pccl.isUnlimited}
                                                      />
                                                      &nbsp;&nbsp;
                                                      <Button
                                                        onClick={() =>
                                                          this.onNOCallRemove(
                                                            i,
                                                            idx,
                                                          )
                                                        }
                                                      >
                                                        x
                                                      </Button>
                                                    </div>
                                                  ),
                                                )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Talk now" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 1050}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked_noc(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      <div
                                        className="mbe_ulmt_show_cont"
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "baseline",
                                        }}
                                      >
                                        {s.checked && (
                                          <>
                                            <FormControl
                                              style={{ width: "inherit" }}
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              value={s.input_value}
                                              placeholder={s.placeholder}
                                              name={s.name}
                                              type="text"
                                              onChange={(e) =>
                                                this.onChange(e, i)
                                              }
                                            />
                                            <Checkbox
                                              disabled={s.isFlashCreditTalkNow}
                                              number={s.id + 100}
                                              key={i + 100}
                                              checked={s.unlimited}
                                              onChange={(e) =>
                                                this.handleUnlimitedMbe(e, i)
                                              }
                                              label="Unlimited"
                                              value={s.unlimited}
                                            />
                                            <Checkbox
                                              disabled={s.unlimited}
                                              number={s.id + 994}
                                              key={i + 994}
                                              checked={s.isFlashCreditTalkNow}
                                              onChange={(e) =>
                                                this.handleFlashCreditTalkNow(
                                                  e,
                                                  i,
                                                )
                                              }
                                              label="Flashcredit"
                                              value={s.isFlashCreditTalkNow}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Insurance" ? (
                                  <Col sm={12}>
                                    <>
                                      <Checkbox
                                        number={s.id + 1015}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked_noi(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      {s.checked && (
                                        <>
                                          <div
                                            className="mbe_ulmt_show_cont"
                                            style={{
                                              display: "inline-flex",
                                            }}
                                          >
                                            <div className="productcat-select">
                                              <Select
                                                isDisabled={!s.checked}
                                                style={{
                                                  width: "inherit !important",
                                                }}
                                                className="react-select primary insurance-dropdown"
                                                classNamePrefix="react-select"
                                                placeholder="Insurance"
                                                name="insurance_id"
                                                value={s.input_value}
                                                onChange={(value) =>
                                                  this.onInsuranceChange(
                                                    value,
                                                    i,
                                                  )
                                                }
                                                options={
                                                  this.state.insuranceUsers
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="productcat-select">
                                            <Button
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              style={{ marginTop: 4 }}
                                              onClick={() =>
                                                this.onNOCallAdd_test(i)
                                              }
                                            >
                                              Add
                                            </Button>
                                            <div className="pct_flaxcontainer">
                                              {s.insurance_key_value.length >
                                                0 &&
                                                s.insurance_key_value.map(
                                                  (x, y) => (
                                                    <div className="productcat_callcontainer">
                                                      <FormControl
                                                        name="address_line_1"
                                                        value={x.address_line_1}
                                                        onChange={(e) =>
                                                          this.handleInputChangeAddresslist1(
                                                            e,
                                                            i,
                                                            y,
                                                          )
                                                        }
                                                        placeholder="Key"
                                                        type="text"
                                                        style={{ width: "98%" }}
                                                      />
                                                      {
                                                        this.state
                                                          .address_line_1Error
                                                      }
                                                      <FormControl
                                                        name="address_line_2"
                                                        value={x.address_line_2}
                                                        onChange={(e) =>
                                                          this.handleInputChangeAddresslist2(
                                                            e,
                                                            i,
                                                            y,
                                                          )
                                                        }
                                                        placeholder="Value"
                                                        type="text"
                                                        style={{ width: "98%" }}
                                                      />
                                                      <Button
                                                        onClick={() =>
                                                          this.onInsuranceRemove(
                                                            i,
                                                            y,
                                                          )
                                                        }
                                                      >
                                                        x
                                                      </Button>
                                                    </div>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                    <hr />
                                  </Col>
                                ) : s.label == "Partner & Coupon Management" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 793}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      {s.checked && (
                                        <>
                                          <div className="productcat-select">
                                            <div className="productcat_callcontainer">
                                              <select
                                                disabled={!s.checked}
                                                className="form-control"
                                                name="tier-select"
                                                onChange={this.onChange_tier}
                                              >
                                                <option value="">
                                                  SELECT TIERS{" "}
                                                </option>
                                                <option value="platinum">
                                                  Platinum
                                                </option>
                                                <option value="gold">
                                                  Gold
                                                </option>
                                                <option value="silver">
                                                  Silver
                                                </option>
                                                <option value="browns">
                                                  Browns
                                                </option>
                                              </select>
                                              &nbsp;
                                              <select
                                                disabled={!s.checked}
                                                className="form-control"
                                                name="tier-select"
                                                onChange={this.onChange_tags}
                                              >
                                                <option value="">
                                                  SELECT TAGS
                                                </option>
                                                {this.state.tagListOption[
                                                  this.state.tiers
                                                ] &&
                                                  this.state.tagListOption[
                                                    this.state.tiers
                                                  ].map((option, index) => (
                                                    <option
                                                      key={index}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  ))}
                                              </select>
                                              &nbsp;
                                              <select
                                                disabled={!s.checked}
                                                className="form-control"
                                                name="tier-select"
                                                onChange={this.onChange_coupons}
                                              >
                                                <option value="">
                                                  SELECT COUPONS{" "}
                                                </option>
                                                {this.state.couponList.map(
                                                  (option, index) => (
                                                    <option
                                                      key={index}
                                                      value={option.id}
                                                    >
                                                      {option.title}
                                                    </option>
                                                  ),
                                                )}
                                              </select>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "8px",
                                              marginLeft: "120px",
                                              padding: "10px",
                                            }}
                                          >
                                            {s.value.map((item, indexs) => (
                                              <div
                                                style={{
                                                  border: "1px solid black",
                                                  borderRadius: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  position: "relative",
                                                  gap: "5px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    color: "black",
                                                    padding: "8px 0px 8px 16px",
                                                  }}
                                                  key={indexs}
                                                >
                                                  {item.title}
                                                </span>

                                                <img
                                                  onClick={() =>
                                                    this.onRemove_coupon(
                                                      i,
                                                      indexs,
                                                    )
                                                  }
                                                  style={{
                                                    padding: "5px",
                                                    background: "transparent",
                                                    cursor: "pointer",
                                                    width: "35px",
                                                    alignSelf: "center",
                                                    color: "black",
                                                  }}
                                                  src="https://w7.pngwing.com/pngs/211/405/png-transparent-computer-icons-close-button-trademark-logo-sign-thumbnail.png"
                                                  alt="remove"
                                                />
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "MBE Groups" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 1020}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedGroups(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      {s.checked && (
                                        <>
                                          <div
                                            className="mbe_ulmt_show_cont"
                                            style={{ display: "inline-flex" }}
                                          >
                                            <div className="productcat-select">
                                              <div className="productcat_callcontainer">
                                                <select
                                                  disabled={!s.checked}
                                                  className="form-control"
                                                  name="tier-select"
                                                  onChange={this.onChangeGroups}
                                                >
                                                  <option value="">
                                                    SELECT Group
                                                  </option>
                                                  {this.state.groupData.map(
                                                    (option, index) => (
                                                      <option
                                                        key={index}
                                                        value={option.id}
                                                      >
                                                        {option.group_name}
                                                      </option>
                                                    ),
                                                  )}
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "8px",
                                              marginLeft: "120px",
                                              padding: "10px",
                                            }}
                                          >
                                            {s.value.map((item, indexs) => (
                                              <div
                                                style={{
                                                  border: "1px solid black",
                                                  borderRadius: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  position: "relative",
                                                  gap: "5px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    color: "black",
                                                    padding: "8px 0px 8px 16px",
                                                  }}
                                                  key={indexs}
                                                >
                                                  {item.group_name}
                                                </span>

                                                <img
                                                  onClick={() =>
                                                    this.onRemove_group(
                                                      i,
                                                      indexs,
                                                    )
                                                  }
                                                  style={{
                                                    padding: "5px",
                                                    background: "transparent",
                                                    cursor: "pointer",
                                                    width: "35px",
                                                    alignSelf: "center",
                                                    color: "black",
                                                  }}
                                                  src="https://w7.pngwing.com/pngs/211/405/png-transparent-computer-icons-close-button-trademark-logo-sign-thumbnail.png"
                                                  alt="remove"
                                                />
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Delivery" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 791}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllCheckedFreeDelivery(
                                            e,
                                            i,
                                          )
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      {s.checked && (
                                        <>
                                          <div style={{ display: "flex" }}>
                                            <FormControl
                                              disabled={
                                                s.checked == true ? false : true
                                              }
                                              placeholder="No Of Free Delivery"
                                              name="noOfFreeDelivery"
                                              type="text"
                                              onChange={(e) =>
                                                this.onChangeDeliveryFields(
                                                  e,
                                                  i,
                                                )
                                              }
                                              value={this.state.noOfFreeValue}
                                            />
                                            <div
                                              style={
                                                s.checked
                                                  ? {
                                                      display: "block",
                                                      width: "100%",
                                                      // marginLeft: "92px",
                                                    }
                                                  : { display: "none" }
                                              }
                                            >
                                              <FormControl
                                                disabled={
                                                  s.checked == true
                                                    ? false
                                                    : true
                                                }
                                                value={
                                                  this.state.deliveryWelcomeNote
                                                }
                                                placeholder="Enter the welcome note"
                                                name="welcomeNote"
                                                type="text"
                                                onChange={(e) =>
                                                  this.onChangeDeliveryFields(
                                                    e,
                                                    i,
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div
                                            style={
                                              s.checked
                                                ? { display: "block" }
                                                : { display: "none" }
                                            }
                                          >
                                            <Row>
                                              <Col sm={s.standard ? 12 : 4}>
                                                <div className="productcat-select">
                                                  <ControlLabel>
                                                    <Checkbox
                                                      disabled={!s.checked}
                                                      number={s.id + 700}
                                                      key={i}
                                                      checked={s.standard}
                                                      onChange={(e) =>
                                                        this.handleStandardDelivery(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      label={<b>Standard</b>}
                                                    />
                                                  </ControlLabel>
                                                  {s.standard && (
                                                    <div className="productcat_callcontainer">
                                                      <>
                                                        <FormControl
                                                          disabled={
                                                            s.standard
                                                              ? false
                                                              : true
                                                          }
                                                          placeholder="No Of Free"
                                                          name="standradFree"
                                                          type="text"
                                                          onChange={(e) =>
                                                            this.onChangeDeliveryFields(
                                                              e,
                                                              i,
                                                              "standard",
                                                            )
                                                          }
                                                          value={
                                                            this.state
                                                              .standardFree
                                                          }
                                                        />
                                                        <FormControl
                                                          disabled={
                                                            s.standard
                                                              ? false
                                                              : true
                                                          }
                                                          placeholder="Enter the Discount"
                                                          name="standradDiscount"
                                                          type="text"
                                                          onChange={(e) =>
                                                            this.onChangeDeliveryFields(
                                                              e,
                                                              i,
                                                              "standard",
                                                            )
                                                          }
                                                          value={
                                                            this.state
                                                              .standardDiscount
                                                          }
                                                        />
                                                        <FormControl
                                                          disabled={
                                                            s.standard
                                                              ? false
                                                              : true
                                                          }
                                                          placeholder="Enter the Base Price"
                                                          name="standradBasePrice"
                                                          type="text"
                                                          onChange={(e) =>
                                                            this.onChangeDeliveryFields(
                                                              e,
                                                              i,
                                                              "standard",
                                                            )
                                                          }
                                                          value={
                                                            this.state
                                                              .standardBasePrice
                                                          }
                                                        />
                                                      </>
                                                    </div>
                                                  )}
                                                </div>
                                              </Col>
                                              <Col sm={s.express ? 12 : 4}>
                                                <div className="productcat-select">
                                                  <ControlLabel>
                                                    <Checkbox
                                                      disabled={!s.checked}
                                                      number={s.id + 701}
                                                      key={i}
                                                      checked={s.express}
                                                      onChange={(e) =>
                                                        this.handleExpressDelivery(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      label={<b>Express</b>}
                                                    />
                                                  </ControlLabel>
                                                  <div className="productcat_callcontainer">
                                                    <>
                                                      {s.express && (
                                                        <>
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .expressFree
                                                            }
                                                            disabled={
                                                              s.express
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="No Of Free"
                                                            name="expressFree"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "express",
                                                              )
                                                            }
                                                          />
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .expressDiscount
                                                            }
                                                            disabled={
                                                              s.express
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="Enter the Discount"
                                                            name="expressDiscount"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "express",
                                                              )
                                                            }
                                                          />
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .expressBasePrice
                                                            }
                                                            disabled={
                                                              s.express
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="Enter the Base Price"
                                                            name="expressBasePrice"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "express",
                                                              )
                                                            }
                                                          />
                                                        </>
                                                      )}
                                                    </>
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col sm={s.islandWide ? 12 : 4}>
                                                <div className="productcat-select">
                                                  <ControlLabel>
                                                    <Checkbox
                                                      disabled={!s.checked}
                                                      number={s.id + 702}
                                                      key={i}
                                                      checked={s.islandWide}
                                                      onChange={(e) =>
                                                        this.handleIslandWideDelivery(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      label={<b>IslandWide</b>}
                                                    />
                                                  </ControlLabel>
                                                  <div className="productcat_callcontainer">
                                                    <>
                                                      {s.islandWide && (
                                                        <>
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .islandWideFree
                                                            }
                                                            disabled={
                                                              s.islandWide
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="No Of Free"
                                                            name="isLandWideFree"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "islandWide",
                                                              )
                                                            }
                                                          />
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .islandWideDiscount
                                                            }
                                                            disabled={
                                                              s.islandWide
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="Enter the Discount"
                                                            name="isLandWideDiscount"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "islandWide",
                                                              )
                                                            }
                                                          />
                                                          <FormControl
                                                            value={
                                                              this.state
                                                                .islandWideBasePrice
                                                            }
                                                            disabled={
                                                              s.islandWide
                                                                ? false
                                                                : true
                                                            }
                                                            placeholder="Enter the Base Price"
                                                            name="isLandWideBasePrice"
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onChangeDeliveryFields(
                                                                e,
                                                                i,
                                                                "islandWide",
                                                              )
                                                            }
                                                          />
                                                        </>
                                                      )}
                                                    </>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </>
                                      )}
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Claim Module" ? (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id + 790}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllClaim(e, i)
                                        }
                                        label={s.label}
                                      />
                                      {s.checked && (
                                        <>
                                          <Row>
                                            <Col
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              style={{ marginRight: "-56px" }}
                                            >
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                Claim Allocation
                                              </ControlLabel>
                                              <FormControl
                                                disabled={
                                                  this.state.isUnlimitedClaim
                                                }
                                                placeholder="Claim Allocation"
                                                name="claimValue"
                                                type="text"
                                                onChange={(e) =>
                                                  this.setState({
                                                    claimValue: e.target.value,
                                                  })
                                                }
                                                value={this.state.claimValue}
                                              />
                                              <br />
                                              {this.state.claimValueError}
                                              &nbsp;
                                            </Col>
                                            <Col sm={2} md={2} lg={2}>
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                Claim Type
                                              </ControlLabel>
                                              &nbsp;
                                              <Select
                                                isDisabled={
                                                  s.checked ? false : true
                                                }
                                                className="pcat_callselect"
                                                placeholder="Claim Type"
                                                onChange={(value) => {
                                                  this.setState({
                                                    claimType: value.value,
                                                  });
                                                }}
                                                options={
                                                  this.state.claimTypeOptions
                                                }
                                                value={this.findClaimType()}
                                              />
                                            </Col>
                                            <Col
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              style={{
                                                marginTop: "32px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {/* <ControlLabel>
                                                                                              Is Unlimited Allocation ?
                                                                                            </ControlLabel>
                                                                                            <br /> */}
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100%",
                                                }}
                                              >
                                                <Checkbox
                                                  number={s.id + 888}
                                                  key={i + 888}
                                                  checked={
                                                    this.state.isUnlimitedClaim
                                                  }
                                                  onChange={(e) => {
                                                    this.setState({
                                                      isUnlimitedClaim:
                                                        e.target.checked,
                                                    });
                                                    if (e.target.checked) {
                                                      this.setState({
                                                        claimValue: "",
                                                      });
                                                    }
                                                  }}
                                                  label="Unlimited Allocation"
                                                  value={
                                                    this.state.isUnlimitedClaim
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              style={{ marginTop: "32px" }}
                                            >
                                              {/* <ControlLabel>
                                                                                              Allow System Claims ?
                                                                                            </ControlLabel>
                                                                                            <br /> */}
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100%",
                                                }}
                                              >
                                                <Checkbox
                                                  number={s.id + 887}
                                                  key={i + 887}
                                                  checked={
                                                    this.state
                                                      .isSystemClaimAllowed
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      isSystemClaimAllowed:
                                                        e.target.checked,
                                                    })
                                                  }
                                                  label="Allow System Claim"
                                                  value={
                                                    this.state.isUnlimitedClaim
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              style={{ marginTop: "32px" }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100% !important",
                                                }}
                                              >
                                                <Checkbox
                                                  style={{
                                                    width: "100% !important",
                                                  }}
                                                  number={s.id + 890}
                                                  key={i + 890}
                                                  checked={
                                                    this.state
                                                      .isBankAccountDetailsDisable
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      isBankAccountDetailsDisable:
                                                        e.target.checked,
                                                    })
                                                  }
                                                  label="Bank Account Details Disable"
                                                  value={
                                                    this.state
                                                      .isBankAccountDetailsDisable
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              style={{ marginTop: "32px" }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100% !important",
                                                }}
                                              >
                                                <Checkbox
                                                  style={{
                                                    width: "100% !important",
                                                  }}
                                                  number={s.id + 884}
                                                  key={i + 884}
                                                  checked={
                                                    this.state
                                                      .splitInvoicesByCompany
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      splitInvoicesByCompany:
                                                        e.target.checked,
                                                    })
                                                  }
                                                  label="Split Invoices By Company"
                                                  value={
                                                    this.state
                                                      .splitInvoicesByCompany
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              style={{ marginTop: "32px" }}
                                            >
                                              {/* <ControlLabel>
                                                                                              Is Bank Account Need ?
                                                                                            </ControlLabel>
                                                                                            <br /> */}
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100% !important",
                                                }}
                                              >
                                                <Checkbox
                                                  style={{
                                                    width: "100% !important",
                                                  }}
                                                  number={s.id + 886}
                                                  key={i + 886}
                                                  checked={
                                                    this.state
                                                      .isBankAccountNeeded
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      isBankAccountNeeded:
                                                        e.target.checked,
                                                    })
                                                  }
                                                  label="Bank Account Needed"
                                                  value={
                                                    this.state.isUnlimitedClaim
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col
                                              sm={3}
                                              md={3}
                                              lg={3}
                                              style={{ marginTop: "32px" }}
                                            >
                                              <div
                                                style={{
                                                  marginTop: "7px",
                                                  marginLeft: "28px",
                                                  width: "100% !important",
                                                }}
                                              >
                                                <Checkbox
                                                  style={{
                                                    width: "100% !important",
                                                  }}
                                                  number={s.id + 883}
                                                  key={i + 883}
                                                  checked={
                                                    this.state
                                                      .deliveryDeductFromClaim
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      deliveryDeductFromClaim:
                                                        e.target.checked,
                                                    })
                                                  }
                                                  label="Deduct Delivery From Claim"
                                                  value={
                                                    this.state
                                                      .deliveryDeductFromClaim
                                                  }
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                          {/* <FormControl
disabled={s.checked ? false : true}
placeholder="Claim Period"
name="claimPeriod"
type="text"
onChange={(e) => this.setState({claimPeriod: e.target.value})}
value={this.state.claimPeriod}
/>
<Select
isDisabled={s.checked ? false : true}
className="pcat_callselect"
placeholder="Type"
value={this.state.claimPeriodType}
options={[
{value: "Day", label: "Day"},
{value: "Month", label: "Month"},
{value: "Year", label: "Year"},
]}
onChange={(value)=>{this.setState({claimPeriodType: value})}}
/> */}
                                          &nbsp;
                                          {/* <Select
                                                isDisabled={
                                                  s.checked ? false : true
                                                }
                                                className="pcat_callselect"
                                                placeholder="Credit Type"
                                                value={this.findFlashCreditType()}
                                                onChange={(value) => {
                                                  this.setState({
                                                    creditType: value.value,
                                                  });
                                                }}
                                                options={
                                                  this.state.creditTypeList
                                                }
                                              /> */}
                                          <Row>
                                            <Col sm={3} md={3} lg={3}>
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                Billing Cycle
                                              </ControlLabel>
                                              &nbsp;
                                              <Select
                                                isDisabled={
                                                  s.checked ? false : true
                                                }
                                                className="pcat_callselect"
                                                placeholder="Billing Cycle"
                                                onChange={(value) => {
                                                  this.setState({
                                                    claimBillingCycle:
                                                      value.value,
                                                  });
                                                }}
                                                options={
                                                  this.state
                                                    .claimBillingCycleOptions
                                                }
                                                value={this.findClaimBillingCycle()}
                                              />
                                            </Col>
                                            <Col sm={3} md={3} lg={3}>
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                OPD Price
                                              </ControlLabel>
                                              <br />
                                              <FormControl
                                                disabled={
                                                  s.checked ? false : true
                                                }
                                                placeholder="Individual Price"
                                                name="individualPrice"
                                                type="text"
                                                onChange={(e) =>
                                                  this.setState({
                                                    opdIndividualPrice:
                                                      e.target.value,
                                                  })
                                                }
                                                value={
                                                  this.state.opdIndividualPrice
                                                }
                                              />
                                            </Col>
                                            <Col sm={3} md={3} lg={3}>
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                Pool Limit
                                              </ControlLabel>
                                              <br />
                                              <FormControl
                                                disabled={
                                                  s.checked ? false : true
                                                }
                                                placeholder="Pool Limit"
                                                name="poolValue"
                                                type="text"
                                                onChange={(e) =>
                                                  this.setState({
                                                    poolValue: e.target.value,
                                                  })
                                                }
                                                value={this.state.poolValue}
                                              />
                                            </Col>
                                            <Col sm={3} md={3} lg={3}>
                                              <ControlLabel
                                                style={{
                                                  paddingTop: "10px",
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                Family Allocation
                                              </ControlLabel>
                                              <FormControl
                                                disabled={
                                                  s.checked &&
                                                  this.state.isClaimFamily
                                                    ? false
                                                    : true
                                                }
                                                placeholder="Family Allocation"
                                                name="familyPrice"
                                                type="text"
                                                onChange={(e) =>
                                                  this.setState({
                                                    opdFamilyPrice:
                                                      e.target.value,
                                                  })
                                                }
                                                value={
                                                  this.state.opdFamilyPrice
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <div
                                            style={
                                              s.checked
                                                ? { display: "block" }
                                                : { display: "none" }
                                            }
                                          >
                                            <Row>
                                              <Col
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                style={{
                                                  paddingLeft: "32px",
                                                }}
                                              >
                                                <ControlLabel
                                                  style={{
                                                    paddingTop: "10px",
                                                    // paddingLeft: "70px",
                                                  }}
                                                >
                                                  Manual Claim Features
                                                </ControlLabel>
                                                <div
                                                // style={{ marginLeft: "70px" }}
                                                >
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 900}
                                                    key={i}
                                                    checked={
                                                      this.state.pharma ==
                                                      "Pharma"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        pharma: e.target.checked
                                                          ? "Pharma"
                                                          : "",
                                                      })
                                                    }
                                                    label="Pharma"
                                                  />
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 90}
                                                    key={i}
                                                    checked={
                                                      this.state.lab == "Lab"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        lab: e.target.checked
                                                          ? "Lab"
                                                          : "",
                                                      })
                                                    }
                                                    label="Lab"
                                                  />
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 91}
                                                    key={i}
                                                    checked={
                                                      this.state.consult ==
                                                      "Consult"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        consult: e.target
                                                          .checked
                                                          ? "Consult"
                                                          : "",
                                                      })
                                                    }
                                                    label="Consult"
                                                  />
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 92}
                                                    key={i}
                                                    checked={
                                                      this.state.hospital ==
                                                      "Hospital"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        hospital: e.target
                                                          .checked
                                                          ? "Hospital"
                                                          : "",
                                                      })
                                                    }
                                                    label="Hospital"
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                          <div
                                            style={
                                              s.checked
                                                ? { display: "block" }
                                                : { display: "none" }
                                            }
                                          >
                                            {/* <div className="pct_flaxcontainer"> */}
                                            <Row>
                                              <Col
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                style={{
                                                  paddingLeft: "32px",
                                                }}
                                              >
                                                <ControlLabel
                                                  style={{
                                                    paddingTop: "10px",
                                                    // paddingLeft: "70px",
                                                  }}
                                                >
                                                  Claim Category
                                                </ControlLabel>
                                                <div
                                                // style={{ marginLeft: "70px" }}
                                                >
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 799}
                                                    key={i}
                                                    checked={
                                                      this.state.isClaimMedicine
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimMedicine:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Medicine"
                                                  />

                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1051}
                                                    key={i}
                                                    checked={
                                                      this.state.isClaimLab
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimLab:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Lab"
                                                  />

                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1001}
                                                    key={i}
                                                    checked={
                                                      this.state.isClaimRaya
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimRaya:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Raya"
                                                  />

                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1002}
                                                    key={i}
                                                    checked={
                                                      this.state.isClaimTalkNow
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimTalkNow:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Talk Now"
                                                  />

                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1003}
                                                    key={i}
                                                    checked={
                                                      this.state
                                                        .isClaimTalkLater
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimTalkLater:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Talk Later"
                                                  />

                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1004}
                                                    key={i}
                                                    checked={
                                                      this.state
                                                        .isClaimTalkGlobal
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimTalkGlobal:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Talk Global"
                                                  />
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1005}
                                                    key={i}
                                                    checked={
                                                      this.state
                                                        .isClaimEchanneling
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isClaimEchanneling:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="E-Channeling"
                                                  />
                                                  <Checkbox
                                                    disabled={!s.checked}
                                                    number={s.id + 1007}
                                                    key={i}
                                                    checked={
                                                      this.state
                                                        .isHospitalization
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        isHospitalization:
                                                          e.target.checked,
                                                      })
                                                    }
                                                    label="Hospitalization"
                                                  />
                                                  <div className="Family_check">
                                                    <Checkbox
                                                      disabled={!s.checked}
                                                      number={s.id + 807}
                                                      key={i}
                                                      checked={
                                                        this.state.isClaimFamily
                                                      }
                                                      onChange={(e) =>
                                                        this.setState({
                                                          isClaimFamily:
                                                            e.target.checked,
                                                        })
                                                      }
                                                      label="Family"
                                                    />
                                                  </div>
                                                  {/* <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid #e3e3e3",
                                                    margin: "10px 0",
                                                  }}
                                                /> */}
                                                  <div>
                                                    {this.state
                                                      .isClaimFamily ? (
                                                      <>
                                                        <div>
                                                          <ControlLabel>
                                                            Select the
                                                            beneficiary
                                                          </ControlLabel>
                                                        </div>
                                                        <div
                                                          style={{
                                                            borderBottom:
                                                              "1px solid #e3e3e3",
                                                            margin: "10px 0",
                                                          }}
                                                        >
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 808}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimMother
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimMother:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Mother"
                                                          />
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 809}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimFather
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimFather:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Father"
                                                          />
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 810}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimSister
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimSister:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Sister"
                                                          />
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 811}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimBrother
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimBrother:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Brother"
                                                          />
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 812}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimSpouse
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimSpouse:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Spouse"
                                                          />
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 813}
                                                            key={i}
                                                            checked={
                                                              this.state
                                                                .isClaimChild
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                isClaimChild:
                                                                  e.target
                                                                    .checked,
                                                              })
                                                            }
                                                            label="Child"
                                                          />
                                                        </div>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>

                                                  {this.state
                                                    .isClaimTalkGlobal ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Talk Global Policy
                                                          Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .talkGlobalPolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "talkGlobal",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {this.state
                                                    .isClaimTalkLater ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Talk Later Policy
                                                          Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .talkLaterPolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "talkLater",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {this.state.isClaimTalkNow ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Talk Now Policy
                                                          Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .talkNowPolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "talkNow",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {this.state.isClaimRaya ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Raya Policy Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .rayaPolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "raya",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {this.state.isClaimLab ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Lab Policy Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .labPolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "lab",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {this.state
                                                    .isClaimMedicine ? (
                                                    <Col
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <ControlLabel>
                                                          Medicine Policy
                                                          Details
                                                        </ControlLabel>
                                                        <Editor
                                                          editorState={
                                                            this.state
                                                              .medicinePolicyDetails
                                                              .value
                                                          }
                                                          editorClassName="terms-editor"
                                                          onEditorStateChange={(
                                                            editorState,
                                                          ) =>
                                                            this.onEditorStateChange(
                                                              "medicine",
                                                              editorState,
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </>
                                      )}
                                    </>
                                    <hr />
                                  </>
                                ) : s.label == "Talk Later Doctor wise" ? (
                                  <Col sm={12}>
                                    <Checkbox
                                      number={s.id}
                                      key={i}
                                      checked={s.checked}
                                      onChange={(e) =>
                                        this.handleAllChecked_noc(e, i)
                                      }
                                      label={s.label}
                                      value={s.chk_value}
                                    />

                                    <div className="productcat-select-doctor">
                                      {s.checked && (
                                        <>
                                          <Button
                                            disabled={!s.checked}
                                            style={{
                                              marginTop: "4px",
                                              marginBottom: "40px",
                                            }}
                                            onClick={() =>
                                              this.onAddNewSpecialityDoctor(i)
                                            }
                                          >
                                            Add
                                          </Button>
                                          <div className="pct_flaxcontainer">
                                            {s.input_value.length > 0 &&
                                              s.input_value.map((pccl, idx) => (
                                                <div className="productcat_callcontainer">
                                                  <Select
                                                    className="pcat_callselect"
                                                    placeholder="doctor name"
                                                    closeMenuOnSelect={true}
                                                    value={pccl.doctorId}
                                                    onChange={(value) =>
                                                      this.onDoctorSelectChange(
                                                        value,
                                                        i,
                                                        idx,
                                                      )
                                                    }
                                                    options={
                                                      this.state.getAllDoctors
                                                    }
                                                  />
                                                  <FormControl
                                                    value={pccl.noOfCalls}
                                                    placeholder="Number of Calls"
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onCallDoctorSpecialityWiseChange(
                                                        e,
                                                        i,
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <Button
                                                    onClick={() =>
                                                      this.onTalkLaterDoctorWiseRemove(
                                                        i,
                                                        idx,
                                                      )
                                                    }
                                                  >
                                                    x
                                                  </Button>
                                                </div>
                                              ))}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    <hr />
                                  </Col>
                                ) : (
                                  <>
                                    <>
                                      <Checkbox
                                        number={s.id}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />
                                      {s.checked && (
                                        <FormControl
                                          disabled={
                                            s.checked == true ? false : true
                                          }
                                          value={s.input_value}
                                          placeholder={s.placeholder}
                                          name={s.name}
                                          type="text"
                                          onChange={(e) => this.onChange(e, i)}
                                        />
                                      )}
                                    </>
                                    <hr />
                                  </>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        </FormGroup>
                        {this.state.feature_chkError}
                      </Col>
                    </Row>
                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editProductCatalogue;
